import axios from "axios";
import { TTP_API_URL } from "Config";
import { throwCatchedError } from "Utils";

export const getLatestArticles = ({
  token,
  limit,
  language = "fr",
  communitiesId = [],
  sourceToken = null
}) => {
  // getLatestArticlesSourceToken = updateSourceToken(
  //   getLatestArticlesSourceToken,
  //   sourceToken
  // );

  const filter = [
    {
      property: "isExternal",
      value: 0,
      operator: "eq"
    },
    {
      property: "status",
      value: "PUBLISHED",
      operator: "like"
    },
    {
      property: "language",
      value: language,
      operator: "like"
    },
    {
      property: "isPrivate",
      value: 0,
      operator: "eq"
    }
  ];

  if (communitiesId.length > 0) {
    filter.push({
      property: "organization.id",
      value: communitiesId,
      operator: "in"
    });
  }

  const sort = [
    {
      property: "publishedAt",
      dir: "desc"
    }
  ];
  const fields = [
    "*",
    "url",
    "author",
    "introduction",
    "main_media",
    "tags",
    "category",
    "image_reduced",
    "organization",
    "avatars",
    "albums"
  ];
  const requestUrl = `${TTP_API_URL}/blog/article`;

  return axios
    .get(requestUrl, {
      // cancelToken: getLatestArticlesSourceToken.token,
      params: {
        access_token: token,
        filter: JSON.stringify(filter),
        sort: JSON.stringify(sort),
        fields: fields.join(","),
        limit
      }
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};



// WEBPACK FOOTER //
// ./src/api/article.js